import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Money } from 'components/Money';
import { calculatePriceCurrency, getPriceFromItem } from 'helpers/Pricing';
import { getConfigurationLineTotal } from 'helpers/DealQuantity';
import { getDealItemBundledExtensionParts } from 'helpers/quoteBundled';
import { useDealConfiguratorContext } from 'modules/deal/DealConfigureScreen';
import { useUser } from 'components/user/UserProvider';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useDealDetailContext } from 'modules/deal/DealDetails';
import './DealItemPanelGroupFooter.scss';
import { useAccount } from 'components/account/AccountProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
import { shouldShowDealItemDateColumn } from 'helpers/formatPlannedDateLabel';
/**
 * @component DealItemPanelGroupFooter
 * @since 1.0.0
 */
export function DealItemPanelGroupFooter(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { style, item, type, deal, editable, hideSKU, itemsGrouped, pricingDisplay, quantityType } = Object.assign({ style: 'normal', editable: true }, props);
    const { discountRep, pricingParametersDisplay, hasDealItemConfigurationTime: hasDealItemConfigurationTimeCfg } = useDealConfiguratorContext();
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const dealConfiguratorContext = useDealConfiguratorContext();
    const quoteContext = useQuoteContext();
    const hasDealItemConfigurationTime = hasDealItemConfigurationTimeCfg ||
        quoteContext.hasDealItemConfigurationTime;
    const dealDetailContext = useDealDetailContext();
    const quoteDealItemFields = quoteContext.dealItemFields.length > 0
        ? quoteContext.dealItemFields
        : dealDetailContext.dealItemFields.length > 0
            ? dealDetailContext.dealItemFields
            : dealConfiguratorContext.dealItemFields;
    const quoteDealItemConfigurationFields = quoteContext.dealItemConfigurationFields.length > 0
        ? quoteContext.dealItemConfigurationFields
        : dealDetailContext.dealItemConfigurationFields.length > 0
            ? dealDetailContext.dealItemConfigurationFields
            : dealConfiguratorContext.dealItemConfigurationFields;
    const configurationFields = quoteContext.configurationFields &&
        quoteContext.configurationFields.length > 0
        ? quoteContext.configurationFields
        : dealConfiguratorContext.configurationFields;
    const plannedDateMode = getConfigurationFieldValue(configurationFields, 'PLANNED_DATE_MODE') ||
        'DATE';
    const dealValue = (_a = deal !== null && deal !== void 0 ? deal : quoteContext.deal) !== null && _a !== void 0 ? _a : dealConfiguratorContext.deal;
    const showDateColumn = shouldShowDealItemDateColumn({
        plannedDateMode,
        editable,
        itemDate: item.date,
        plannedDateStart: dealValue === null || dealValue === void 0 ? void 0 : dealValue.plannedDateStart
    });
    const quantityTypeValue = quantityType && quantityType != ''
        ? quantityType
        : dealConfiguratorContext.quantityType != ''
            ? dealConfiguratorContext.quantityType
            : quoteContext.quantityType;
    const currency = ((_b = quoteContext.deal) === null || _b === void 0 ? void 0 : _b.currency)
        ? (_c = quoteContext.deal) === null || _c === void 0 ? void 0 : _c.currency
        : deal === null || deal === void 0 ? void 0 : deal.currency;
    const user = useUser();
    let costPrice = 0;
    let dealerDiscount = 0;
    let dealerPriceTotal = 0;
    let amountTotal = 0;
    let showTotal = true;
    let packages = undefined;
    let options = undefined;
    switch (type) {
        case 'item':
            costPrice = calculatePriceCurrency(item.variant && item.variant.price
                ? item.variant.price
                : ((_d = item.item.price) !== null && _d !== void 0 ? _d : 0), deal === null || deal === void 0 ? void 0 : deal.currency);
            dealerDiscount = (_e = (discountRep * costPrice) / 100) !== null && _e !== void 0 ? _e : 0;
            dealerPriceTotal = (_f = costPrice - dealerDiscount) !== null && _f !== void 0 ? _f : 0;
            amountTotal = (_g = item.price * item.quantity) !== null && _g !== void 0 ? _g : 0;
            if (pricingDisplay === 'BUNDLED') {
                amountTotal = getDealItemBundledExtensionParts(item, dealValue).bundledExtension;
            }
            if (amountTotal == 0) {
                showTotal = false;
            }
            break;
        case 'package':
        case 'packageProposed':
            packages = (_h = item.packages) === null || _h === void 0 ? void 0 : _h.filter((packageItem) => type === 'package' ? !packageItem.proposed : packageItem.proposed);
            packages === null || packages === void 0 ? void 0 : packages.forEach((configuration) => {
                costPrice += calculatePriceCurrency((configuration === null || configuration === void 0 ? void 0 : configuration.package) && (configuration === null || configuration === void 0 ? void 0 : configuration.package.price)
                    ? configuration.package.price
                    : 0, deal === null || deal === void 0 ? void 0 : deal.currency);
            });
            dealerDiscount = (_j = (discountRep * costPrice) / 100) !== null && _j !== void 0 ? _j : 0;
            dealerPriceTotal = (_k = costPrice - dealerDiscount) !== null && _k !== void 0 ? _k : 0;
            amountTotal =
                (_l = packages === null || packages === void 0 ? void 0 : packages.reduce((acc, curr) => {
                    var _a, _b, _c;
                    return acc +
                        getConfigurationLineTotal((_a = curr.price) !== null && _a !== void 0 ? _a : 0, (_b = curr.quantity) !== null && _b !== void 0 ? _b : 0, (_c = curr.package) === null || _c === void 0 ? void 0 : _c.quantityCalculation, dealValue);
                }, 0)) !== null && _l !== void 0 ? _l : 0;
            break;
        case 'option':
        case 'optionProposed':
            options = (_m = item.options) === null || _m === void 0 ? void 0 : _m.filter((option) => type === 'option' ? !option.proposed : option.proposed);
            options === null || options === void 0 ? void 0 : options.forEach((configuration) => {
                var _a, _b;
                costPrice += getPriceFromItem(item.item, (_a = item.variant) !== null && _a !== void 0 ? _a : null, (_b = configuration.item) !== null && _b !== void 0 ? _b : null, 'option', deal === null || deal === void 0 ? void 0 : deal.currency);
            });
            dealerDiscount = (_o = (discountRep * costPrice) / 100) !== null && _o !== void 0 ? _o : 0;
            dealerPriceTotal = (_p = costPrice - dealerDiscount) !== null && _p !== void 0 ? _p : 0;
            amountTotal =
                (_q = options === null || options === void 0 ? void 0 : options.reduce((acc, curr) => {
                    var _a, _b, _c;
                    return acc +
                        getConfigurationLineTotal((_a = curr.price) !== null && _a !== void 0 ? _a : 0, (_b = curr.quantity) !== null && _b !== void 0 ? _b : 0, (_c = curr.item) === null || _c === void 0 ? void 0 : _c.quantityCalculation, dealValue);
                }, 0)) !== null && _q !== void 0 ? _q : 0;
            break;
        default:
            break;
    }
    const className = classNames('deal-item-panel-group-footer', 'deal-item-panel-group-footer-' + style, props.className);
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: className },
            React.createElement("td", null, pricingDisplay !== 'BUNDLED' ? t('Subtotal') : null),
            hideSKU === 'FALSE' && React.createElement("td", null),
            (type !== 'option' && type !== 'optionProposed') ||
                ((type === 'option' || type === 'optionProposed') && !itemsGrouped) ? (React.createElement("td", null)) : null,
            type !== 'item' && hasDealItemConfigurationTime && React.createElement("td", null),
            type === 'item' && showDateColumn && React.createElement("td", null),
            type === 'item' &&
                quoteDealItemFields.length > 0 &&
                (quoteDealItemFields === null || quoteDealItemFields === void 0 ? void 0 : quoteDealItemFields.map((field) => React.createElement("td", { key: field.id }))),
            type !== 'item' &&
                quoteDealItemConfigurationFields.length > 0 &&
                (quoteDealItemConfigurationFields === null || quoteDealItemConfigurationFields === void 0 ? void 0 : quoteDealItemConfigurationFields.map((field) => (React.createElement("td", { key: field.id })))),
            type === 'item' && React.createElement("td", null),
            type !== 'item' && quantityTypeValue !== 'GLOBAL' && React.createElement("td", null),
            editable && (React.createElement("td", { className: "deal-item-panel-group-content-price" },
                React.createElement(Money, { value: costPrice }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { className: "deal-item-panel-group-content-price" },
                React.createElement(Money, { value: dealerDiscount }))),
            editable && user.isContactUser() && dealerColumn && (React.createElement("td", { className: "deal-item-panel-group-content-price" },
                React.createElement(Money, { value: dealerPriceTotal }))),
            editable && pricingParametersDisplay == 'item' && type === 'item' && (React.createElement("td", null)),
            editable && pricingParametersDisplay == 'line' && React.createElement("td", null),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'LINE' ||
                editable) && React.createElement("td", null),
            (pricingDisplay === 'ALL' ||
                pricingDisplay === 'LINE' ||
                editable) && (React.createElement("td", { className: "deal-item-panel-group-content-price" }, showTotal && React.createElement(Money, { value: amountTotal }))),
            React.createElement("td", null, (pricingDisplay === 'ALL' ||
                pricingDisplay === 'LINE' ||
                editable) &&
                showTotal &&
                (currency === null || currency === void 0 ? void 0 : currency.code)),
            pricingDisplay === 'BUNDLED' && (React.createElement(React.Fragment, null,
                React.createElement("td", null),
                React.createElement("td", null))))));
}
